module.exports = __webpack_public_path__ + "static/media/load1.78f1a825.gif";